import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../bookChapter.style';
import { GetBookChapters, DeleteBookChapter } from "../../../DAL/BooksChapters/bookChapters";
import { GetBooks } from "../../../DAL/Books/books";
import { GetLanguage } from "../../../DAL/Language/language";
import { enqueueSnackbar } from "notistack";
import { useLocation } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const useBookChapter = () => {
  const classes = useStyles();
  const query = useQuery();
  const bookId = query.get('bookId');
  
  const [BookChapterData, setBookChapterData] = useState([]);
  const [languageData, setlanguageData] = useState([]);
  const [bookData, setBookData] = useState([]);
  const [BookChapterCount, setBookChapterCount] = useState(0);
  const [singleBookChapter, setsingleBookChapter] = useState('');
  const [open, setOpen] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [searchKey, setSearchKey] = useState("chapterName")
  
  const tableCells = [
    { id: 'bookId', title: 'Book Name' },
    { id: 'chapterName', title: 'Chapter Name' },
    { id: 'chapterNo', title: 'Chapter No' },
    { id: 'url', title: 'URL' },
    { id: 'actions', title: 'Action(s)' },
  ];
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} />, action: "delete" },
    { icon: <CreateIcon className={classes.iconStyle} />, action: "edit" },
  ];

  useEffect(() => {
    getBookChaptersData(page, limit, search, searchKey, bookId);
  }, [page, limit, search, bookId]);

  useEffect(() => {
    getLanguagesData()
    getBooksData()
  }, [])

  const getBookChaptersData = useCallback(async(page, limit, search, searchKey, bookId) => {
    setIsLoading(true)
    let data = {
      page: Math.max(page + 1, 1),
      limit: limit,
      value: search,
      key: searchKey,
      bookId: bookId ? bookId : "",
    }
    const response = await GetBookChapters(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setBookChapterData(response?.data?.rows);
          setBookChapterCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, [bookId, enqueueSnackbar]);

  const getLanguagesData = useCallback(async() => {
        let data = false;
        const response = await GetLanguage(data);
            if (response.statusCode == 200) {
              const languageRes = response?.data?.rows?.map(item => ({
                value: item.id,
                text: item.name
              }));
              setlanguageData(languageRes);
            } else {
              if (typeof response.message == "string") {
                enqueueSnackbar(response.message, { variant: "error" });
              } else {
                enqueueSnackbar("Invalid credentials", { variant: "error" });
              }
            }
      }, []);

  const getBooksData = useCallback(async() => {
      let data = false;
      const response = await GetBooks(data);
          if (response.statusCode == 200) {
            const languageRes = response?.data?.rows?.map(item => ({
              value: item.id,
              text: item.bookName
            }));
            setBookData(languageRes);
          } else {
            if (typeof response.message == "string") {
              enqueueSnackbar(response.message, { variant: "error" });
            } else {
              enqueueSnackbar("Invalid credentials", { variant: "error" });
            }
          }
    }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteBookChapter(id); 
        if (response.statusCode == 200) {
          getBookChaptersData(page, limit, search, searchKey, bookId)
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    console.log("Action clicked:", index, row);
    setsingleBookChapter(row);
    // dispatch(getsingleBookChapterOrderData(row));
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
      console.log("Update action set, singleBookChapter:", row);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
    if (isTrue) {
      setPage(newPage - 1);
    } else {
      setPage(newPage);
    }
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleBookChapterSearch = useCallback(value => {
    setSearch(value);
    setPage(0);
    setLimit(10);
  }, []);

  const handleDropDown = useCallback(value => {
      setSearchKey(value);
      if(search) {
      getBookChaptersData(0, 10, search, value, bookId);
      }
    }, []);

  const handleGetBookChapterData = useCallback(value => {
    getBookChaptersData(page, limit, search, searchKey, bookId)
  }, []);

  

  return {
    BookChapterData,
    languageData,
    bookData,
    BookChapterCount,
    singleBookChapter,
    open,
    orderModal,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    searchKey,
    setOpen,
    setOrderModal,
    handleGetBookChapterData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleBookChapterSearch,
    handleDropDown,
  };
};
